import styled from '@emotion/styled';

export default styled('a')(({ theme }) => ({
  color: theme.palette.primary,
  textDecoration: 'inherit',
}));
